module.exports = __webpack_public_path__ + "static/media/finalDesignIllustration.da759d5a.jpg";